import React from 'react';
import ReactDOM from "react-dom";
import PropTypes from "prop-types";


function Portal ({ openModal, domNode }) {
    return ReactDOM.createPortal (
        <span className='accommodationsMapTriggerComponent' onClick={() => openModal(domNode.dataset.nezzokontikifrontendAccommodationmapAccommodationUid)}>
            {domNode.dataset.nezzokontikifrontendAccommodationmapOpenmap}
        </span>, domNode
    );
}

Portal.propTypes = {
    openModal: PropTypes.func,
    domNode: PropTypes.node
};

export default Portal;



// WEBPACK FOOTER //
// ./src/components/Map/Portal.js